import { u as uniqueId } from './uniqueId-85d83a57.js';
import { t as transitionEndEventName } from './transitionEndEventName-a2ae6d4b.js';
import Vue from 'vue';
import { i as isMobile } from './DeviceHelper-fc6808f9.js';
import { n as normalizeComponent } from './normalize-component-cf2db48b.js';
import { c as createInjector } from './browser-ac904bdc.js';

const manager = new Vue({
  data() {
    return {
      current: null
    };
  }
});
var manager$1 = manager;

const MdSnackbar = {
  name: "md-snackbar",
  props: {
    id: [String, Number],
    mdPosition: {
      type: String,
      default: "bottom center"
    },
    mdDuration: {
      type: [String, Number],
      default: 4000
    },
    mdHeight: {
      type: [String, Number],
      default: 48
    },
    mdWarn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      snackbarId: this.id || "snackbar-" + uniqueId(),
      removedSnackBarElementEventName: "removedSnackBarElement",
      active: false,
      rootElement: {},
      snackbarElement: {},
      directionClass: null,
      closeTimeout: null,
      removedSnackBarElementEvent: null,
      footersOffset: 0,
      mutationObserver: null
    };
  },
  computed: {
    classes() {
      let cssClasses = {
        "md-active": this.active
      };
      this.directionClass = this.mdPosition.replace(/ /g, "-");
      cssClasses["md-position-" + this.directionClass] = true;
      return cssClasses;
    },
    offsetHeight() {
      return {
        transform: `translate3D(0, calc(100% - ${this.footersOffset}px), 0)`
      };
    }
  },
  watch: {
    active(active) {
      const directionClass = "md-has-toast-" + this.directionClass;
      const toastClass = "md-has-toast";
      if (active) {
        document.body.classList.add(directionClass);
        document.body.classList.add(toastClass);
      } else {
        document.body.classList.remove(directionClass);
        document.body.classList.remove(toastClass);
      }
    }
  },
  methods: {
    getFootersHeight() {
      if (document) {
        const footers = document.querySelectorAll(".md-footer:not(.torreBanner--embedded)");
        let footersHeight = 0;
        if (footers.length) {
          footers.forEach(footer => {
            footersHeight += footer.offsetHeight;
          });
        }
        const tdsNavigationTabs = document.querySelector(".tds-navigation-tabs");
        if (tdsNavigationTabs && window.innerWidth < 720) {
          footersHeight += tdsNavigationTabs.offsetHeight;
        }
        return footersHeight;
      }
    },
    getMdHeight() {
      const snackbarContainer = this.$refs.container;
      if ((snackbarContainer === null || snackbarContainer === void 0 ? void 0 : snackbarContainer.clientHeight) > this.mdHeight) {
        return snackbarContainer.clientHeight;
      }
      return this.mdHeight;
    },
    updatePosition() {
      const mdDialog = document ? document.querySelector(".tdl-full-screen-dialog") : null;
      const mdHeight = this.getMdHeight();
      this.footersOffset = mdDialog ? mdHeight : this.getFootersHeight() + mdHeight;
    },
    removeElement() {
      if (document.body.contains(this.snackbarElement) && !this.active) {
        const activeRipple = this.snackbarElement.querySelector(".md-ripple.md-active");
        if (activeRipple) {
          activeRipple.classList.remove("md-active");
        }
        document.body.removeChild(this.snackbarElement);
      }
      document.dispatchEvent(this.removedSnackBarElementEvent);
    },
    open() {
      this.updatePosition();
      if (manager$1.current) {
        document.removeEventListener(this.removedSnackBarElementEventName, this.showElementAndStartTimer);
        document.addEventListener(this.removedSnackBarElementEventName, this.showElementAndStartTimer);
        manager$1.current.close();
        return;
      }
      this.showElementAndStartTimer();
    },
    showElementAndStartTimer() {
      if (document.body.contains(this.snackbarElement)) {
        return;
      }
      this.pendingDuration = this.mdDuration;
      document.removeEventListener(this.removedSnackBarElementEventName, this.showElementAndStartTimer);
      manager$1.current = this;
      document.body.appendChild(this.snackbarElement);
      if (this.$refs.container !== null && this.$refs.container !== undefined) {
        window.getComputedStyle(this.$refs.container).backgroundColor;
      }
      this.active = true;
      this.updatePosition();
      this.$emit("open");
      if (this.mdDuration !== Infinity) {
        this.setCloseTimeout(this.mdDuration);
      }
      this.timeoutStartedAt = Date.now();
    },
    close() {
      this.pauseTimeout();
      if (this.$refs.container) {
        this.active = false;
        this.footersOffset = 0;
        const removeElement = () => {
          document.removeEventListener(transitionEndEventName, removeElement);
          this.removeElement();
        };
        manager$1.current = null;
        this.$emit("close");
        document.removeEventListener(transitionEndEventName, removeElement);
        document.addEventListener(transitionEndEventName, removeElement);
        this.clearCloseTimeout();
        this.pendingDuration = this.mdDuration;
      }
    },
    pauseTimeout() {
      if (isMobile()) return false;
      if (this.timeoutStartedAt !== 0) {
        this.pendingDuration = this.pendingDuration - (Date.now() - this.timeoutStartedAt);
        this.pendingDuration = Math.max(this.pendingDuration, 0);
      }
      this.clearCloseTimeout();
    },
    resumeTimeout() {
      if (isMobile()) return false;
      this.timeoutStartedAt = Date.now();
      if (this.pendingDuration === Infinity) {
        return;
      }
      this.setCloseTimeout(this.pendingDuration);
    },
    setCloseTimeout(delay) {
      this.clearCloseTimeout();
      this.closeTimeout = window.setTimeout(this.close, delay);
    },
    clearCloseTimeout() {
      if (!this.closeTimeout) {
        return;
      }
      window.clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    },
    updateOnDomChange(mutationsList) {
      mutationsList.forEach(mutation => {
        if (mutation.attributeName === "class") {
          const hasBottomBar = mutation.target.classList.contains("has-candidate-bar");
          let bottomBarAdded = false;
          if (hasBottomBar && !bottomBarAdded) {
            this.updatePosition();
            bottomBarAdded = true;
          }
        }
        if (mutation.removedNodes.length > 0) {
          this.updatePosition();
        }
      });
    },
    setupMutationObserver() {
      const mutationObserver = new MutationObserver(mutationsList => this.updateOnDomChange(mutationsList));
      const observerConfig = {
        attributes: true,
        childList: true
      };
      mutationObserver.observe(document.body, observerConfig);
      this.mutationObserver = mutationObserver;
    }
  },
  mounted() {
    this.setupMutationObserver();
    this.$nextTick(() => {
      this.snackbarElement = this.$el;
      this.snackbarElement.parentNode.removeChild(this.snackbarElement);
      this.timeoutStartedAt = 0;
      this.pendingDuration = this.mdDuration;
    });
    this.removedSnackBarElementEvent = new Event(this.removedSnackBarElementEventName);
  },
  beforeDestroy() {
    this === null || this === void 0 || this.mutationObserver.disconnect();
    this.clearCloseTimeout();
    this.active = false;
    this.removeElement();
  }
};

const __vue_script__ = MdSnackbar;
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "md-snackbar",
    class: [_vm.classes],
    attrs: {
      "id": _vm.snackbarId
    }
  }, [_c('div', {
    ref: "container",
    staticClass: "md-snackbar-container",
    style: [_vm.offsetHeight]
  }, [_c('div', {
    staticClass: "md-snackbar-content",
    class: [{
      'md-warn': _vm.mdWarn
    }]
  }, [_vm._t("default")], 2)])]);
};
var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-1062a3ec_0", {
    source: ".md-snackbar{display:flex;position:fixed;right:0;left:0;z-index:120;pointer-events:none;transition:all .4s cubic-bezier(.25,.8,.25,1);transition-property:margin-top,margin-bottom}.md-snackbar .md-ink-ripple{color:rgba(0,0,0,.87)}.md-snackbar .md-snackbar-container{background-color:#e3e3e3;color:rgba(0,0,0,.87)}.md-snackbar.md-position-bottom-center,.md-snackbar.md-position-top-center{justify-content:center}.md-snackbar.md-position-bottom-right,.md-snackbar.md-position-top-right{margin-right:24px;justify-content:flex-end}.md-snackbar.md-position-bottom-left,.md-snackbar.md-position-top-left{margin-left:24px;justify-content:flex-start}.md-snackbar.md-position-top-center,.md-snackbar.md-position-top-left,.md-snackbar.md-position-top-right{margin-top:24px}.md-snackbar.md-position-bottom-left,.md-snackbar.md-position-bottom-right{margin-bottom:24px}.md-snackbar.md-position-top-center,.md-snackbar.md-position-top-left,.md-snackbar.md-position-top-right{top:0}.md-snackbar.md-position-top-center .md-snackbar-container,.md-snackbar.md-position-top-left .md-snackbar-container,.md-snackbar.md-position-top-right .md-snackbar-container{transform:translate3D(0,calc(-100% - 24px),0)}.md-snackbar.md-position-bottom-center,.md-snackbar.md-position-bottom-left,.md-snackbar.md-position-bottom-right{bottom:0}.md-snackbar.md-position-bottom-center .md-snackbar-container,.md-snackbar.md-position-bottom-left .md-snackbar-container,.md-snackbar.md-position-bottom-right .md-snackbar-container{transform:translate3D(0,calc(100% + 24px),0)}.md-snackbar.md-active .md-snackbar-container{transform:translate3D(0,0,0)}.md-snackbar.md-active .md-snackbar-content{opacity:1;transition:opacity .4s .1s cubic-bezier(.25,.8,.25,1)}@media (max-width:600px){.md-snackbar{margin:0!important}}.md-snackbar .md-snackbar-content{display:flex;align-items:center;justify-content:space-between;opacity:0;transition:opacity .2s cubic-bezier(.25,.8,.25,1);will-change:opacity}.md-snackbar .md-button{min-width:88px;margin:-8px -4px}.md-snackbar .md-button:last-child{margin-left:48px}.md-snackbar .md-button.md-accent:not(.md-icon-button){color:#98a520}.md-snackbar .md-warn .md-button{color:#a00303}.md-snackbar-container{width:auto;min-width:288px;max-width:568px;min-height:48px;padding:14px 16px;overflow:hidden;pointer-events:auto;border-radius:2px;transition:all .4s cubic-bezier(.25,.8,.25,1);font-size:14px}@media (max-width:600px){.md-snackbar-container{width:100%;max-width:100%;border-radius:0}}.md-has-toast-top-right .md-fab.md-fab-top-right{transform:translate3D(0,68px,0)}@media (max-width:600px){.md-has-toast-top-right .md-fab.md-fab-top-right{transform:translate3D(0,48px,0)}}.md-has-toast-top-center .md-fab.md-fab-top-center{transform:translate3D(-50%,68px,0)}@media (max-width:600px){.md-has-toast-top-center .md-fab.md-fab-top-center{transform:translate3D(-50%,48px,0)}}.md-has-toast-top-left .md-fab.md-fab-top-left{transform:translate3D(0,68px,0)}@media (max-width:600px){.md-has-toast-top-left .md-fab.md-fab-top-left{transform:translate3D(0,48px,0)}}.md-has-toast-bottom-right .md-fab.md-fab-bottom-right{transform:translate3D(0,-68px,0)}@media (max-width:600px){.md-has-toast-bottom-right .md-fab.md-fab-bottom-right{transform:translate3D(0,-48px,0)}}.md-has-toast-bottom-center .md-fab.md-fab-bottom-center{transform:translate3D(-50%,-68px,0)}@media (max-width:600px){.md-has-toast-bottom-center .md-fab.md-fab-bottom-center{transform:translate3D(-50%,-48px,0)}}.md-has-toast-bottom-left .md-fab.md-fab-bottom-left{transform:translate3D(0,-68px,0)}@media (max-width:600px){.md-has-toast-bottom-left .md-fab.md-fab-bottom-left{transform:translate3D(0,-48px,0)}}",
    map: undefined,
    media: undefined
  });
};
const __vue_scope_id__ = undefined;
const __vue_module_identifier__ = undefined;
const __vue_is_functional_template__ = false;
const __vue_component__ = normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

export { __vue_component__ as default };
